module.exports = __webpack_public_path__ + "static/media/owl.0e4d4d68.png";